import {Component, OnDestroy, OnInit} from '@angular/core';
import {RegistryService} from '../../services/registry.service';
import {AuthService} from '../../../../services/auth.service';
import {WishlistService} from '../../services/wishlist.service';
import {Wishlist} from '../../models/Wishlist/Wishlist';
import {TranslateService} from '@ngx-translate/core';
import {Campaign} from '../../../admin/models/campaign';
import {environment} from '../../../../environments/environment';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    result: any = [];
    catTitle1;
    catTitle2;
    catTitle3;
    catTitle4;

    cat1;
    cat2;
    cat3;
    cat4;

    wishList: Wishlist = null;
    isCustomer;


    FullCategories: any = [];
    Cat: any;

    campaigns: Campaign[] = null;
    env = environment;

    configsLoadedEvent;
    userLoggedOutEvent;
    userLoggedEvent;
    catsLoadedEvent;
    settingsLoadedEvent;


    constructor(public registry: RegistryService,
                public translate: TranslateService,
                public authService: AuthService, private wishlistService: WishlistService) {

        this.configsLoadedEvent = this.registry.ConfigsLoadedEvent$.subscribe(configs => {

            this.setWidgetsConfig();

        });

        this.settingsLoadedEvent = this.registry.SettingsLoadedEvent$.subscribe(settings => {

            this.campaigns = settings.campaigns;
        })

        this.catsLoadedEvent = this.registry.CatsLoadedEvent$.subscribe(cats => {
            this.FullCategories = cats;
            this.Cat = this.FullCategories.filter(v => v.id === 1184);
            this.registry.cat = this.Cat;
            this.setWidgetsConfig();


        });


        // this.userLoggedOutEvent = this.authService.UserLoggedOutEvent$.subscribe(() => {
        //
        //    this.wishList = null;
        //    this.registry.wishList = null;
        //    this.isCustomer = undefined ;
        //
        //
        // });
        //
        // this.userLoggedEvent = this.authService.UserLoggedInEvent$.subscribe(customer => {
        //    this.getCustomerWishList();
        //    this.isCustomer = true;
        //
        //
        //
        //
        // });


    }


    ngOnInit() {

        // this.FullCategories = this.registry.getFullCat();


        this.translate.use(this.wishlistService.getCurrentLang());
        this.setWidgetsConfig();
        if (this.registry.customer !== undefined) {
            this.getCustomerWishList();
        }
    }

    setWidgetsConfig() {
        //  this.registry.mobileConfigs.components = configs.components;
        console.log(this.registry.cat);
        if (this.registry.cat) {
            this.catTitle4 = this.registry.cat[0].name;

        }
        if (this.registry.mobileConfigs) {
            this.catTitle1 = this.registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat1_title');
            this.catTitle2 = this.registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat2_title');
            this.catTitle3 = this.registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat3_title');
            // this.catTitle4 = this.registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat4_title');
            // if (this.Cat) {
            // }

            this.cat1 = this.registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat1_category');
            // this.cat1 = 1109;
            this.cat2 = this.registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat2_category');
            // this.cat3 = registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat3_category');
            // this.cat4 = registry.mobileConfigs.getConfigKeyByComponent('productgroups', 'fp_cat4_category');
        }
    }

    ngOnDestroy(): void {

        this.configsLoadedEvent.unsubscribe();

        if (this.catsLoadedEvent) {
            this.catsLoadedEvent.unsubscribe();
        }

        if (this.settingsLoadedEvent) {
            this.settingsLoadedEvent.unsubscribe();
        }

    }

    getCustomerWishList() {
        if (this.registry.customer !== undefined) {
            this.wishlistService.getCustomerWishlist().subscribe(data => {
                this.wishList = data;
                this.wishlistService.wishList = data;
                this.registry.wishList = data;
            });
        }
    }


// // Snackbar that opens with failure background
//   openFailureSnackBar(){
//     this.snackBar.open("Invalid Login Credentials", "Try again!", {
//       duration: 3000,
//       panelClass: ['red-snackbar','login-snackbar'],
//     });
//   }

}
